import { FC } from 'react'
import Link from 'next/link'
import classNames from 'classnames'

import Button from 'components/forms/Button'

type Props = {
  className?: string
}

const LearnMoreAu: FC<Props> = ({ className }) => {
  return (
    <div
      className={classNames(
        'd-flex flex-column align-items-center fw-semibold gap-5',
        className,
      )}
    >
      <span className='fs-fluid-24-34 '>Want to learn more?</span>
      <Link href='/au/enterprise#konnect-form'>
        <Button className='w-100 w-lg-auto'>Book a Demo</Button>
      </Link>
      <span className='fs-20 '>
        or{' '}
        <Link className='text-decoration-none' href='/au/contact-us'>
          Contact Us
        </Link>
      </span>
    </div>
  )
}

export default LearnMoreAu
